export default __webpack_public_path__ + "static/media/428.a0851a68.jpg";